import React from 'react';
import TeamChat from '../../components/TeamChat';
import { MessageCircle } from 'lucide-react';

const AdminTeamChat = () => {
  return (
    <div className="min-h-screen bg-black text-white p-4 sm:p-8">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-full bg-pink-500/20 flex items-center justify-center">
            <MessageCircle className="w-7 h-7 text-pink-400" />
          </div>
          <div>
            <h1 className="text-3xl font-bold">Team Chat</h1>
            <p className="text-zinc-400 text-sm">Private staff channel — barbers + admin</p>
          </div>
        </div>
        <TeamChat height="75vh" />
      </div>
    </div>
  );
};

export default AdminTeamChat;
